import React from "react";
import "./AboutModal.css";

function AboutModal({
  onClose,
  onContactClick,
  langString,
}) {
  const handleContactClick = () => {
    onClose();
    onContactClick();
  };

  return (
    <>
      <div className="about-overlay" onClick={(e) => {
        if (e.target === e.currentTarget) {
          e.stopPropagation();
          onClose();
        }
      }} />
      <div className="about-modal">
        <button
          className="about-close"
          onClick={onClose}
          aria-label="Close About"
        >
          ✕
        </button>
        <div className="about-content">
          <div className="about-text">
            {langString === "nl" ? (
              <>
                <h2 className="about-title">Over WordHit</h2>
                <p className="about-paragraph">
                Als piloot zit je niet alleen hoog in de lucht, maar ook vaak diep in je hoofd. Ik ben Jeroen, en wie piloot wil worden, krijgt al vroeg te maken met IQ tests en mentale selecties. Die breinuitdagingen voelden voor mij niet als een obstakel, maar juist als iets leuks. Die fascinatie bleef.
                </p>
                <p className="about-paragraph">
                  Tijdens lange vluchten, hoog boven de oceaan, als de automatische piloot het werk doet en de tijd traag voorbijgaat, begon mijn brein te spelen. Met puzzels, woorden en ideeën. Wat als je je brein kunt trainen zoals je lichaam, op een leuke, laagdrempelige en prikkelende manier?
                </p>
                <p className="about-paragraph">
                  Zo ontstonden, ergens tussen twee continenten, de eerste ideeën voor WordHit en SmartFriends. Tot lichte wanhoop van collega’s die weer naar “nog een idee” moesten luisteren en nergens heen konden 😉.
                </p>
                <p className="about-paragraph about-paragraph-last">
                  Wat begon uit verveling op tien kilometer hoogte, groeide uit tot spellen die taal, denken en plezier samenbrengen. Soms ontstaan de beste ideeën niet op kantoor, maar boven de wolken.
                </p>
                <p className="about-paragraph about-paragraph-fun">
                  Veel plezier met WordHit!
                </p>
              </>
            ) : (
              <>
                <h2 className="about-title">About WordHit</h2>
                <p className="about-paragraph">
                  As a pilot, you are not only high up in the air, but also often deep in your own head. My name is Jeroen, and anyone who wants to become a pilot is confronted early on with IQ tests and mental selection processes. Brain challenges didn't feel like an obstacle to me, but something I genuinely enjoyed. That fascination stayed with me.
                </p>
                <p className="about-paragraph">
                  During long flights, high above the ocean, when the autopilot does its job and time seems to slow down, my mind began to play. With puzzles, words, and ideas. What if you could train your brain just like your body, in a fun, accessible, and stimulating way?
                </p>
                <p className="about-paragraph">
                  Somewhere between two continents, the first ideas for WordHit and SmartFriends were born. Much to the mild despair of colleagues who had to listen to yet another "idea" and had nowhere to go 😉.
                </p>
                <p className="about-paragraph about-paragraph-last">
                  What started as boredom at ten kilometers altitude grew into games that bring language, thinking, and fun together. Sometimes the best ideas are not born in an office, but above the clouds.
                </p>
                <p className="about-paragraph about-paragraph-fun">
                  Have fun with WordHit!
                </p>
              </>
            )}
          </div>
          <button className="about-contact-button" onClick={handleContactClick}>
            {langString === "nl" ? "CONTACT" : "CONTACT"}
          </button>
        </div>
      </div>
    </>
  );
}

export default AboutModal;

